import Carousel from 'Assets/js/lib/carousel'
;(function () {
  const components = {
    halfBannerBlocksCarousel: SAXX.Init.Component((node) => {
      new Carousel(node, { cell: '.product-card' })
    }),
  }
  Object.assign(SAXX.Init.Components, components)
})()
